const isValidAppSchema = (nonSecure: unknown): boolean => {
  if (!nonSecure) return false;

  // Disallow if it starts with a protocol scheme like http, https, ftp to avoid xss attack
  const forbiddenProtocolRegex = /^(https?|ftp):\/\//i;

  // Allow only strings like com.example.app or myapp.desktop (letters, numbers, dashes, dots)
  // only alphanumeric characters (A–Z, a–z, and 0–9), hyphens (-), and periods (.)
  const allowedFormatRegex = /^[a-zA-Z0-9.-]+$/;

  return !forbiddenProtocolRegex.test(`${nonSecure}`) && allowedFormatRegex.test(`${nonSecure}`);
};

export default isValidAppSchema;
